import {Button, Input, InputNumber, Modal, Select} from "antd";

const Option = Select.Option;
export default function EditAccessGroup({props}) {

  return <Modal
    visible={props.isOpen}
    title="Edit Access Group"
    onOk={props.submitEdit}
    onCancel={props.toggleEditPopup}
    footer={[
      <Button key="back"
              onClick={props.toggleEditPopup}>
        Return
      </Button>,
      <Button type="primary"
              key="submit"
              className={'btn btn-success'}
              loading={props.loading}
              onClick={props.submitEdit}>
        Submit
      </Button>
    ]}>
    <div className="p-2">
      <span>Access Group Name</span>
      <Input placeholder="Add Access Group Name"
             value={props.name}
             onChange={(e) => props.setName(e.target.value)}/>
    </div>

    <div className="p-2">
      <span>Courses</span>
      <Select
          showSearch
          value={props.selectedCourses}
          onChange={(e) => {
            props.setSelectedCourses(e)
          }}
          size="default"
          mode='multiple'
          placeholder={'Select Courses'}
          filterOption={(input, option) =>
              option?.props?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          className="w-100percent ant-input new-flex mw-150">
        {props.courses?.map((mode, index) => (
            <Option value={mode.id} key={index}>
              {mode.course_name}
            </Option>
        ))}
      </Select>
    </div>

    <div className="p-2">
      <span>Sku</span>
      <Input placeholder="Input Sku"
             value={props.sku}
             onChange={(e) => props.setSKU(e.target.value)}/>
    </div>

    <div className="p-2">
      <span>Duration</span>
      <InputNumber placeholder="Input Duration(Days)"
                   className="w-100percent"
                   min={1}
                   max={100000}
                   value={props.duration}
                   onChange={(e) => props.setDuration(e)} />
    </div>

    <div className="p-2">
      <span>Access Type</span>
      <Input value={props.editingData?.access_type} disabled />
    </div>
  </Modal>
}
